import Workbench from "./Workbench";

const App = () => {
  return <Workbench />;
};

export default App;
